import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';

import { DashboardService } from 'src/app/modules/service/dashboard.service';
import Swal from 'sweetalert2';

interface Role {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-update-admin',
  templateUrl: './update-admin.component.html',
  styleUrls: ['./update-admin.component.scss']
})
export class UpdateAdminComponent implements OnInit {
  roles: Role[] = [
    {value: 'manager', viewValue: 'Manager'},
    {value: 'admin', viewValue: 'Admin'},
  ];
  
  userdata;
  regm={
    email:'',
    firstName:'',
    lastName:'',
    //branch:'',
    new_manager_email:'',
    phone:'',
    role:'admin'
  }

  addmanagerform: FormGroup;

  ghPhonePattern = /^(0)[2354789]\d{8}$/; // Ghana local format: 10 digits starting with 0 and valid network prefix


  constructor(public formBuilder: FormBuilder,public service: DashboardService, private router:Router,public dialogRef: MatDialogRef<UpdateAdminComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

     this.addmanagerform = this.formBuilder.group({
      firstName: new FormControl(data.firstName,[Validators.required]),
      lastName: new FormControl(data.lastName,[Validators.required]),
      new_manager_email: new FormControl(data.email,[Validators.required]),
      phone: new FormControl(data.phone,[Validators.required]),
      role: new FormControl(data.role,[Validators.required]),
    })
  }

  ngOnInit() {
    this.userdata=JSON.parse(localStorage.getItem('userdata'))
  }

  updatemanager(){
    this.regm = this.addmanagerform.value;

  if(this.addmanagerform.valid) {
     this.regm = this.addmanagerform.value;
     this.regm.email = this.userdata.email;
      //var test = JSON.stringify(this.regm);
      // console.log(this.regm);
      Swal.showLoading();
      this.service.updateManager(this.regm)
      .subscribe(response => {
        // console.log(response);
        Swal.close();
        if (response['responseCode'] === '000') {

        (Swal as any).fire({
          icon:'success',
          title: 'Successful',
        text:'Manager Account updated  Successfully.',
        });
        this.dialogRef.close({event:'updated'});
        //this.router.navigate(['/signupmanager'])


        } else {
          (Swal as any).fire({
            icon:'warning',
            title: 'Oops...',
            text: response['responseMessage'],
            footer: ''
          });
        }

      }, error => {
        (Swal as any).fire({
          icon:'error',
          title: 'Oops...',
          text: error,
          footer: ''
        });
        Swal.close();
      })
    } else {
      (Swal as any).fire({
        icon:'warning',
        title: 'Oops...',
        text: 'Please fill all form fields',
        footer: ''
      });
    }

  }
}
